import { AgencyService } from '@/services/agency-service'
import { UserService } from '@/services/user-service'
import { mergeAgencyContact } from '@/models/agency-contact'
import type { WriteBackIntents } from './write-back-intents'

export {
  emptyWriteBacks,
  hasWriteBacks,
  type WriteBackIntents,
} from './write-back-intents'

// ============================================================
// Profile write-back: the wizard's central promise is that the
// details it collects become the SAVED details ({{...}} tokens
// then resolve to them), so live-linking is never a leap of
// faith. Steps accumulate intents; nothing is written until the
// user finishes ("Open in editor") — backing out writes nothing.
// ============================================================

/**
 * Persists the accumulated intents. Both writes re-read current server
 * state first: the preferences endpoint needs a complete customize
 * document, and the agency-profile PUT REPLACES the stored profile — a
 * stale base would wipe fields the wizard never touched (e.g. the
 * recruiter's redaction preferences).
 */
export async function commitWriteBacks(
  agencyId: string,
  intents: WriteBackIntents
): Promise<void> {
  if (Object.keys(intents.agencyContact).length > 0) {
    const prefs = await AgencyService.getAgencyPreferences(agencyId)
    const customize = mergeAgencyContact(prefs.customize, intents.agencyContact)
    await AgencyService.updateAgencyPreferences(agencyId, { customize })
  }
  if (Object.keys(intents.recruiter).length > 0) {
    const current = await UserService.getAgencyProfile(agencyId)
    await UserService.updateAgencyProfile(agencyId, {
      ...(current.recruiterProfile ?? {}),
      ...intents.recruiter,
    })
  }
}
